module.exports = __webpack_public_path__ + "img/linkedin.6db8983d.svg";